<template>
    <div class="kb-folder-page">
    <!-- 移动端菜单按钮 -->
    <div v-if="isMobile && isSidebarCollapsed" class="mobile-menu-btn" @click="toggleSidebar">
      <span class="menu-icon">☰</span>
    </div>
    
    <!-- 移动端遮罩层 -->
    <div v-if="isMobile && !isSidebarCollapsed" class="sidebar-overlay" @click="toggleSidebar"></div>
    
    <div class="sidebar" :class="{ 'collapsed': isSidebarCollapsed && isMobile }">
        <!-- 移动端关闭按钮 -->
        <div v-if="isMobile && !isSidebarCollapsed" class="sidebar-close" @click="toggleSidebar">×</div>
        
        <img class="folder-icon" :src="imgBase64 ? imgBase64 : require('../../assets/images/knowledgeBase/kb-icon.png')" alt="知识库" />
        <div class="kb-description">
            <h1>{{ currentFolder }}</h1>
            <p>{{ detail }}</p>
            <hr style="margin-top: 20px ;"/>
        </div>
      <!-- Vertical panel menu -->
      <ul class="panel-menu">
        <li @click="changePanel('datasets')" :style="activePanel=='datasets'? selectedStyle:normalStyle">数据集</li>
        <li @click="changePanel('knowledge')" :style="activePanel=='knowledge'? selectedStyle:normalStyle">知识检索</li>
        <li @click="changePanel('settings')" :style="activePanel=='settings'? selectedStyle:normalStyle">设置</li>
      </ul>
    </div>
    <div class="content" :class="{ 'full-width': isSidebarCollapsed && isMobile }">
      <!-- Right panel content -->
      <div v-if="activePanel === 'datasets'">
        <KbDataPage :currentUserId="currentUserId"/>
        <!-- Data Sets panel content -->
        <!-- Add your code here -->
      </div>
      <div v-else-if="activePanel === 'knowledge'">
        <!-- Knowledge Search panel content -->
        <!-- Add your code here -->
        <KbRagPage :currentUserId="currentUserId"/>
      </div>
      <div v-else-if="activePanel === 'settings'">
        <KbSettingPage :folderName="currentFolder" :currentUserId="currentUserId"/>
        <!-- Settings panel content -->
        <!-- Add your code here -->
      </div>
    </div>
  </div>
</template>

<script>
import KbSettingPage from '../pannels/KbSettingPage.vue';
import KbDataPage from '../pannels/KbDataPage.vue';
import KbRagPage from '../pannels/KbRagPage.vue';
import{getkbConfig} from '../../api/auth';
export default {
  name: 'KbFolderPage',
  components: {
    KbSettingPage,
    KbDataPage,
    KbRagPage,
  },
  data() {
    return {
      activePanel: 'datasets', // Default active panel
      currentFolder: '', // Current folder being viewed
      detail:'',
      imgBase64: '',
      selectedStyle: {
        color: '#187EFF',
        fontWeight: 'bold',
        backgroundColor: 'rgba(24,126,255,0.1)',
      },
      normalStyle: {
        color: 'black',
      },
      currentUserId: '',
      isMobile: false,
      isSidebarCollapsed: false
    };
  },

  methods: {
    changePanel(panel) {
      this.activePanel = panel;
      // 移动端切换面板后自动收起侧边栏
      if (this.isMobile) {
        this.isSidebarCollapsed = true;
      }
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
      if (this.isMobile) {
        this.isSidebarCollapsed = true;
      } else {
        this.isSidebarCollapsed = false;
      }
    }
  },
  created() {
    // Add any initialization logic here
    this.currentFolder = this.$route.params.folderName; // Set the current folder to root
    this.currentUserId = this.$route.query.currentUserId;
    console.log('当前文件夹：',this.currentFolder);
  },
  mounted() {
    // 监听窗口大小变化
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    
    // Add any mounted logic here
    // Fetch folder details
    // Fetch folder details
    getkbConfig(this.currentUserId,this.currentFolder).then((res)=>{
        //console.log('获取知识库配置文件1',res);
        this.detail = res.data.config.detail;
        this.imgBase64 = res.data.config.imgBase64;
        console.log('获取图片Base64编码',this.imgBase64);
      })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.kb-folder-page {
  position:fixed;
  flex-direction: column;
  display: flex;
  top: 80px;
  width:100%;
  height:100%;
  overflow:auto;
}

.sidebar {
  display: flex;
  flex-direction: column;
  position:absolute;
  top: 0px;
  bottom: 0px;
  width: 300px;
  background-color: #F4F7FF;
  z-index: 100;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.folder-icon {
  width: 100px;
  height: 100px;
  margin: 20px;
  border-radius: 50px;
}


.panel-menu {
  list-style-type: none;
  padding: 0;
  margin-top: 30px;
}

.panel-menu li {
  padding: 10px;
  cursor: pointer;
}

.content {
  flex: 1;
  padding: 20px;
  margin-left: 300px;
  transition: margin-left 0.3s ease;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  position: fixed;
  top: 90px;
  left: 10px;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
}

.mobile-menu-btn:hover {
  background: #f5f5f5;
  transform: scale(1.1);
}

.mobile-menu-btn .menu-icon {
  font-size: 20px;
  color: #333;
  line-height: 1;
}

/* 侧边栏关闭按钮 */
.sidebar-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  z-index: 101;
}

.sidebar-close:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* 遮罩层 */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  .kb-folder-page {
    top: 60px;
  }

  .sidebar {
    position: fixed;
    top: 60px;
    left: 0;
    width: 280px;
    height: calc(100vh - 60px);
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }

  .sidebar.collapsed {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
  }

  .content {
    margin-left: 0;
    padding: 15px;
    padding-top: 60px;
  }

  .content.full-width {
    margin-left: 0;
  }

  .folder-icon {
    width: 80px;
    height: 80px;
    margin: 15px;
    border-radius: 40px;
  }

  .kb-description h1 {
    font-size: 18px;
    margin-left: 15px;
  }

  .kb-description p {
    font-size: 14px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .panel-menu li {
    padding: 15px;
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .sidebar {
    width: 100%;
  }
}
</style>
